import { Rule } from 'components/core-v2'
import { ClearButton } from 'components/core-v2/atoms/buttons/clear-button'
import { Legend } from 'components/core-v2/atoms/legend'
import { CheckboxField } from 'components/core-v2/molecules/fields/checkbox-field'
import { DropdownMenu } from 'components/core-v2/organisms/dropdown-menu'
import { useCallback } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import styles from './index.module.scss'

export const TRADES_FILTERS_FIELDS = [
  'trades-active',
  'trades-closing',
  'trades-closed',
  'trades-suspended',
  'trades-model',
  'trades-self-select',
  'trades-fund-of-funds',
  'trades-delta-one',
  'trades-constant-proportion-leverage',
  'trades-risk-managed',
  'trades-volatility-control-leverage',
  'trades-continuous-protection',
  'trades-term-protection'
]

export const TradesFilters = () => {
  const formValues = useWatch()
  const { setValue } = useFormContext()

  const onClearClick = useCallback(() => {
    TRADES_FILTERS_FIELDS.forEach(fieldId => setValue(fieldId, false))
  }, [setValue])

  const areAnyFiltersSelected = Object.entries(formValues).some(([id, value]) => {
    if (!TRADES_FILTERS_FIELDS.includes(id)) return false
    return value
  })

  const label = `Trade filters (${areAnyFiltersSelected ? 'Filters selected' : 'All'})`

  return (
    <>
      <DropdownMenu className={styles.root} id="trades-filters-menu" label={label}>
        <fieldset className="flex-column">
          <Legend>Status</Legend>
          <CheckboxField id="trades-active" label="Active" />
          <CheckboxField id="trades-closing" label="Closing" />
          <CheckboxField id="trades-closed" label="Closed" />
          <CheckboxField id="trades-suspended" label="Suspended" />
        </fieldset>
        <Rule className="my-6" />
        <fieldset className="flex-row">
          <Legend>Portfolios</Legend>
          <CheckboxField className="mr-4" id="trades-model" label="Model" />
          <CheckboxField className="mr-4" id="trades-self-select" label="Self select" />
          <CheckboxField id="trades-fund-of-funds" label="Fund of funds" />
        </fieldset>
        <Rule className="my-6" />
        <fieldset className="flex-column">
          <Legend>Strategies</Legend>
          <CheckboxField id="trades-delta-one" label="Delta 1" />
          <CheckboxField
            id="trades-constant-proportion-leverage"
            label="Constant proportion leverage"
          />
          <CheckboxField id="trades-risk-managed" label="Risk managed" />
          <CheckboxField
            id="trades-volatility-control-leverage"
            label="Volatility control leverage"
          />
          <CheckboxField id="trades-continuous-protection" label="Continuous protection" />
          <CheckboxField id="trades-term-protection" label="Term protection" />
        </fieldset>
      </DropdownMenu>
      {areAnyFiltersSelected && (
        <ClearButton onClick={onClearClick}>Clear trade filters</ClearButton>
      )}
    </>
  )
}
